import React, { useState, useEffect } from "react";
import firebase from "firebase";
import StyleFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

const queryParameters = new URLSearchParams(window.location.search);
    const redirect2 = queryParameters.get("redirect");
    console.log(redirect2);

   

var uiConfig = {
  signInFlow: "popup",
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: async (authResult) => {
      const userInfo = authResult.additionalUserInfo;
      if (userInfo.isNewUser && userInfo.providerId === "password") {
        try {
          await authResult.user.sendEmailVerification({
            url: redirect2,
          });
          console.log("Check your email.");
        } catch (e) {
          console.log(e);
        }
      }
      return false;
    },
  },
};

const signOut = () => {
  firebase
    .auth()
    .signOut()
    .then(function () {
      console.log("Successufully Signed out");
    })
    .catch(function () {
      console.log("Error Signed out");
    });
};

const Signup = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = firebase.auth().currentUser;
    const authObserver = firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
    });
    return authObserver;
  });

  console.log("user", user);

  const mode = queryParameters.get("mode");
  
  if (mode == 'verifyEmail') {
    const of_id = queryParameters.get("id");
    const api_key = queryParameters.get("api_key");
    document.body.innerHTML = '<div id="preloader" style="display: block;"><div data-loader="dual-ring"></div></div>';
    const urls = "https://profitpay.vip/actions/partners_domain.php?apikey=" + api_key;


    fetch(urls) 
    
    // Converting received data to JSON 
    .then(response => response.json()) 
    .then(json => { 
      let status = json.status;
      if (status == 'good') {
        let rand = Math.random().toString(36).substr(2, 10);
        let partner_domain = json.url + '?' + 'u=a4y234&o=' + of_id + '&r=' + rand; 
        setTimeout(() => window.location.replace(partner_domain), 3000);
      }
      if (status == 'traffback') {
        let partner_domain = json.url; 
        setTimeout(() => window.location.replace(partner_domain), 3000);
      }
}); 
  }
  if (user) {
    return (
      <div>
        <p>
          Welcome, {user.displayName} <br />
          <small>{user.email}</small> <br />
          <button onClick={signOut}>Sign out</button>
        </p>
      </div>
    );
  } else {
    return (
      <div>
        <div>Sign up / Register</div>
        
        <StyleFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
      </div>
    );
  }
};

export default Signup;



// WEBPACK FOOTER //
// ./src/Signup.js